export const BOOKING_HERO_BACKGROUND_SCREEN_IDS = Object.freeze([
  "search",
  "categories",
  "extras",
  "guest_details",
  "payment",
  "confirmation",
]);

// Before screen-level configuration existed, the image was rendered on these
// three screens. Treat a missing setting as that legacy behaviour, while
// preserving an explicit empty array as "nowhere".
export const DEFAULT_BOOKING_HERO_BACKGROUND_SCREENS = Object.freeze([
  "search",
  "payment",
  "confirmation",
]);

export function normalizeBookingHeroBackgroundScreens(value, entryMode = "hosted") {
  const source = Array.isArray(value)
    ? value
    : DEFAULT_BOOKING_HERO_BACKGROUND_SCREENS;
  const requested = new Set(source.map((screen) => String(screen || "").trim()));
  const isWidget = entryMode === "widget";

  return BOOKING_HERO_BACKGROUND_SCREEN_IDS.filter(
    (screen) => requested.has(screen) && !(isWidget && screen === "search")
  );
}

export function isBookingHeroBackgroundEnabled(value, screen, entryMode = "hosted") {
  const normalizedScreen = String(screen || "").trim();
  return normalizeBookingHeroBackgroundScreens(value, entryMode).includes(normalizedScreen);
}
